/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2017 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/

import { LayoutService } from "./../../register-login/services/layoutservice.service";
import { retry } from "rxjs/operators";
import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Location } from "@angular/common";
import { Router } from "@angular/router";
import { LandingPageService } from "src/app/shared/services/landingPage/landing-page.service";
import { environment } from "src/environments/environment";


@Component({
  selector: "app-landing-page",
  templateUrl: "./landing-page.component.html",
  styleUrls: ["./landing-page.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class LandingPageComponent implements OnInit {
  isServerError = false;
  filterName ='';
  public columnDefs: any;
  columndef() {
    const customComparator = (a, b) => {
      if (typeof a === "string") {
        return a.localeCompare(b);
      } else {
        return a > b ? 1 : a < b ? -1 : 0;
      }
    };

    this.columnDefs = [
      {
        headerName: "Id",
        field: "id",
        width: 100,
        cellClass: "columndefs",
        suppressMovable: true,
        unSortIcon: true,
        comparator: customComparator,
      },
      {
        headerName: "Url",
        field: "uri",
        width: 340,
        cellClass: "u-idcolumn",
        suppressMovable: true,
        unSortIcon: true,
        comparator: customComparator
       },
      {
        headerName: "Page",
        field: "page_number",
        width: 240,
        cellClass: "columndefs",
        suppressMovable: true,
        unSortIcon: true,
        comparator: customComparator,
      },
      {
        headerName: "Description",
        field: "text",
        width: 420,
        cellClass: "columndefs",
        suppressMovable: true,
        unSortIcon: true,
        comparator: customComparator,
      }     
    ];
  }
  constructor(
    private router: Router,
    private location: Location,
    public landingService: LandingPageService,
    private _layoutService: LayoutService
  ) { this.columndef();}

  rowData =[]
 
  listdata = [{
    id: 12,
    uri: "gs://trawick_pdf_upload_bucket/test4.pdf",
    page_number: "1",
    text: "Page 2 of 3\nEEO Compliance and Harassment Policy\nApril 16, 2019\n.\nOur continued success in equal employment opportunity and affirmative action\ndepends not only on the commitment and involvement of those directly\nresponsible for the program's implementation but also on the dedication of all\nemployees."
  }, {
    id: 13,
    uri: "gs://trawick_pdf_upload_bucket/test4.pdf",
    page_number: "2",
    text: "Page 2 of 3\nEEO Compliance and Harassment Policy\nApril 16, 2019\n.\nOur continued success in equal employment opportunity and affirmative action\ndepends not only on the commitment and involvement of those directly\nresponsible for the program's implementation but also on the dedication of all\nemployees."
  }, {
    id: 14,
    uri: "gs://trawick_pdf_upload_bucket/test4.pdf",
    page_number: "3",
    text: "Page 2 of 3\nEEO Compliance and Harassment Policy\nApril 16, 2019\n.\nOur continued success in equal employment opportunity and affirmative action\ndepends not only on the commitment and involvement of those directly\nresponsible for the program's implementation but also on the dedication of all\nemployees."
  }, {
    id: 15,
    uri: "gs://trawick_pdf_upload_bucket/test4.pdf",
    page_number: "5",
    text: "Page 2 of 3\nEEO Compliance and Harassment Policy\nApril 16, 2019\n.\nOur continued success in equal employment opportunity and affirmative action\ndepends not only on the commitment and involvement of those directly\nresponsible for the program's implementation but also on the dedication of all\nemployees."
  }, {
    id: 16,
    uri: "gs://trawick_pdf_upload_bucket/test4.pdf",
    page_number: "6",
    text: "Page 2 of 3\nEEO Compliance and Harassment Policy\nApril 16, 2019\n.\nOur continued success in equal employment opportunity and affirmative action\ndepends not only on the commitment and involvement of those directly\nresponsible for the program's implementation but also on the dedication of all\nemployees."
  }, {
    id: 17,
    uri: "gs://trawick_pdf_upload_bucket/test4.pdf",
    page_number: "7",
    text: "Page 2 of 3\nEEO Compliance and Harassment Policy\nApril 16, 2019\n.\nOur continued success in equal employment opportunity and affirmative action\ndepends not only on the commitment and involvement of those directly\nresponsible for the program's implementation but also on the dedication of all\nemployees."
  }, {
    id: 18,
    uri: "gs://trawick_pdf_upload_bucket/test4.pdf",
    page_number: "8",
    text: "Page 2 of 3\nEEO Compliance and Harassment Policy\nApril 16, 2019\n.\nOur continued success in equal employment opportunity and affirmative action\ndepends not only on the commitment and involvement of those directly\nresponsible for the program's implementation but also on the dedication of all\nemployees."
  }, {
    id: 19,
    uri: "gs://trawick_pdf_upload_bucket/test4.pdf",
    page_number: "9",
    text: "Page 2 of 3\nEEO Compliance and Harassment Policy\nApril 16, 2019\n.\nOur continued success in equal employment opportunity and affirmative action\ndepends not only on the commitment and involvement of those directly\nresponsible for the program's implementation but also on the dedication of all\nemployees."
  }, {
    id: 20,
    uri: "gs://trawick_pdf_upload_bucket/test4.pdf",
    page_number: "9",
    text: "Page 2 of 3\nEEO Compliance and Harassment Policy\nApril 16, 2019\n.\nOur continued success in equal employment opportunity and affirmative action\ndepends not only on the commitment and involvement of those directly\nresponsible for the program's implementation but also on the dedication of all\nemployees."
  }, {
    id: 21,
    uri: "gs://trawick_pdf_upload_bucket/test4.pdf",
    page_number: "10",
    text: "Page 2 of 3\nEEO Compliance and Harassment Policy\nApril 16, 2019\n.\nOur continued success in equal employment opportunity and affirmative action\ndepends not only on the commitment and involvement of those directly\nresponsible for the program's implementation but also on the dedication of all\nemployees."
  }, {
    id: 22,
    uri: "gs://trawick_pdf_upload_bucket/test4.pdf",
    page_number: "9",
    text: "Page 2 of 3\nEEO Compliance and Harassment Policy\nApril 16, 2019\n.\nOur continued success in equal employment opportunity and affirmative action\ndepends not only on the commitment and involvement of those directly\nresponsible for the program's implementation but also on the dedication of all\nemployees."
  }, {
    id: 23,
    uri: "gs://trawick_pdf_upload_bucket/test4.pdf",
    page_number: "11",
    text: "Page 2 of 3\nEEO Compliance and Harassment Policy\nApril 16, 2019\n.\nOur continued success in equal employment opportunity and affirmative action\ndepends not only on the commitment and involvement of those directly\nresponsible for the program's implementation but also on the dedication of all\nemployees."
  }, {
    id: 24,
    uri: "gs://trawick_pdf_upload_bucket/test4.pdf",
    page_number: "13",
    text: "Page 2 of 3\nEEO Compliance and Harassment Policy\nApril 16, 2019\n.\nOur continued success in equal employment opportunity and affirmative action\ndepends not only on the commitment and involvement of those directly\nresponsible for the program's implementation but also on the dedication of all\nemployees."
  }, {
    id: 25,
    uri: "gs://trawick_pdf_upload_bucket/test4.pdf",
    page_number: "15",
    text: "Page 2 of 3\nEEO Compliance and Harassment Policy\nApril 16, 2019\n.\nOur continued success in equal employment opportunity and affirmative action\ndepends not only on the commitment and involvement of those directly\nresponsible for the program's implementation but also on the dedication of all\nemployees."
  }, {
    id: 26,
    uri: "gs://trawick_pdf_upload_bucket/test4.pdf",
    page_number: "14",
    text: "Page 2 of 3\nEEO Compliance and Harassment Policy\nApril 16, 2019\n.\nOur continued success in equal employment opportunity and affirmative action\ndepends not only on the commitment and involvement of those directly\nresponsible for the program's implementation but also on the dedication of all\nemployees."
  }, {
    id: 27,
    uri: "gs://trawick_pdf_upload_bucket/test4.pdf",
    page_number: "17",
    text: "Page 2 of 3\nEEO Compliance and Harassment Policy\nApril 16, 2019\n.\nOur continued success in equal employment opportunity and affirmative action\ndepends not only on the commitment and involvement of those directly\nresponsible for the program's implementation but also on the dedication of all\nemployees."
  }, {
    id: 28,
    uri: "gs://trawick_pdf_upload_bucket/test4.pdf",
    page_number: "19",
    text: "Page 2 of 3\nEEO Compliance and Harassment Policy\nApril 16, 2019\n.\nOur continued success in equal employment opportunity and affirmative action\ndepends not only on the commitment and involvement of those directly\nresponsible for the program's implementation but also on the dedication of all\nemployees."
  }, {
    id: 29,
    uri: "gs://trawick_pdf_upload_bucket/test4.pdf",
    page_number: "19",
    text: "Page 2 of 3\nEEO Compliance and Harassment Policy\nApril 16, 2019\n.\nOur continued success in equal employment opportunity and affirmative action\ndepends not only on the commitment and involvement of those directly\nresponsible for the program's implementation but also on the dedication of all\nemployees."
  }, {
    id: 19,
    uri: "gs://trawick_pdf_upload_bucket/test4.pdf",
    page_number: "19",
    text: "Page 2 of 3\nEEO Compliance and Harassment Policy\nApril 16, 2019\n.\nOur continued success in equal employment opportunity and affirmative action\ndepends not only on the commitment and involvement of those directly\nresponsible for the program's implementation but also on the dedication of all\nemployees."
  }, {
    id: 30,
    uri: "gs://trawick_pdf_upload_bucket/test4.pdf",
    page_number: "19",
    text: "Page 2 of 3\nEEO Compliance and Harassment Policy\nApril 16, 2019\n.\nOur continued success in equal employment opportunity and affirmative action\ndepends not only on the commitment and involvement of those directly\nresponsible for the program's implementation but also on the dedication of all\nemployees."
  }, {
    id: 31,
    uri: "gs://trawick_pdf_upload_bucket/test4.pdf",
    page_number: "19",
    text: "Page 2 of 3\nEEO Compliance and Harassment Policy\nApril 16, 2019\n.\nOur continued success in equal employment opportunity and affirmative action\ndepends not only on the commitment and involvement of those directly\nresponsible for the program's implementation but also on the dedication of all\nemployees."
  }, {
    id: 32,
    uri: "gs://trawick_pdf_upload_bucket/test4.pdf",
    page_number: "19",
    text: "Page 2 of 3\nEEO Compliance and Harassment Policy\nApril 16, 2019\n.\nOur continued success in equal employment opportunity and affirmative action\ndepends not only on the commitment and involvement of those directly\nresponsible for the program's implementation but also on the dedication of all\nemployees."
  }]
  filterdata=[];
  Start = 0;
  Limit = 4;
 
  ngOnInit() {
      //this.rowData =[...this.listdata];
    }
 
  closeErrorModal() {
    this.isServerError = false;
    this._layoutService.logout();
  }
  redirectPage(event){
    
    if (event.column.getColId() === "uri") {
      console.log(event);
      window.open(event.value, "_blank");
    }
  }
  filterSearch(name){
   this.filterdata =[...this.listdata];
   this.Start =0;
   this.rowData=[];
   if(name.length>0){
        this.filterdata.forEach(element => {
          if (element['page_number'] == name || element['id'] == name) {
            this.rowData.push(element)
          }
        });
     console.log(this.rowData);
   }else{
     this.rowData = [];
   }
  

  }
  pageUp(start){
    window.scroll(0, 0);
    this.Start = start+1
  }
  pageDown(start) {
    window.scroll(0, 0);
      this.Start = start-1
  }
  numberOfPages(total,limit){
   
     return Math.ceil(total / limit);
  }
}
